// extracted by mini-css-extract-plugin
module.exports = {"iconList":"SixOrNot_iconList__22_8r","iconListItem":"SixOrNot_iconListItem__SezoS"};